import React from 'react';
import { Delete, Edit } from '@mui/icons-material';
import {
  Avatar,
  Box,
  Chip,
  IconButton,
  Switch,
  Typography,
} from '@mui/material';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}));

const PRIORITY_STYLES = {
  low: {
    label: 'Low',
    bg: 'rgba(76, 175, 80, 0.12)',
    color: '#2e7d32',
    border: '1px solid rgba(46, 125, 50, 0.3)',
  },
  medium: {
    label: 'Medium',
    bg: 'rgba(255, 152, 0, 0.12)',
    color: '#ef6c00',
    border: '1px solid rgba(239, 108, 0, 0.3)',
  },
  high: {
    label: 'High',
    bg: 'rgba(244, 67, 54, 0.12)',
    color: '#c62828',
    border: '1px solid rgba(198, 40, 40, 0.3)',
  },
};

const ReminderCard = ({
  reminder,
  data,
  onEdit,
  onDelete,
  onActiveChange,
}) => {
  const priorityKey = (data?.priority || '').toString().toLowerCase();
  const priorityConfig = PRIORITY_STYLES[priorityKey];

  return (
    <Box
      className='flexBox'
      sx={{
        alignItems: 'center',
        border: '1px solid gray',
        p: 2,
        borderRadius: 3,
        justifyContent: 'space-between',
        flexWrap: 'wrap',
      }}
    >
      <Box
        className='flexBox flexColumn flexWrap'
        sx={{
          gap: 2,
          width: '70%',
        }}
      >
        <Box
          className='flexBox flexColumn flexWrap'
          sx={{ alignItems: 'start', gap: 3 }}
        >
          <Box className='flexBox' gap={2} alignItems={'center'}>
            <Avatar src={reminder.patientPhotoURL} />
            <Typography
              variant='h6'
              sx={{
                fontFamily: 'Lato',
                textTransform: 'capitalize',
              }}
            >
              {reminder.name}
            </Typography>
            {priorityConfig && (
              <Chip
                label={priorityConfig.label}
                size='small'
                sx={{
                  fontWeight: 700,
                  backgroundColor: priorityConfig.bg,
                  color: priorityConfig.color,
                  border: priorityConfig.border,
                  textTransform: 'uppercase',
                  letterSpacing: 0.5,
                }}
              />
            )}
          </Box>
          {data?.message && (
            <Typography
              sx={{
                fontFamily: 'Lato',
                fontWeight: 'bold',
                backgroundColor: '#9291f0',
                color: '#fff',
                p: 2,
                borderRadius: 3,
              }}
            >
              {data?.message}
            </Typography>
          )}
        </Box>
        <Box className='flexBox flexWrap' sx={{ gap: 2 }}>
          <>
            {data?.dates.map((item, index) => (
              <Chip
                key={`date-${index}`}
                label={
                  typeof item === 'object' ? item.toString() : item
                }
                color='primary'
                variant='outlined'
              />
            ))}
            {data?.times?.map((item, index) => (
              <Chip
                key={`time-${index}`}
                label={
                  typeof item === 'object' ? item.toString() : item
                }
                color='success'
                variant='outlined'
              />
            ))}
          </>
        </Box>
      </Box>
      <Box className='flexBox' gap={1} alignSelf={'center'}>
        <LightTooltip title='Edit'>
          <IconButton onClick={() => onEdit(data, reminder?.id)}>
            <Edit color='primary' />
          </IconButton>
        </LightTooltip>
        <LightTooltip title='Delete'>
          <IconButton onClick={() => onDelete(data?.id, reminder?.id)}>
            <Delete color='error' />
          </IconButton>
        </LightTooltip>
        <LightTooltip title={data.active ? 'Active' : 'Inactive'}>
          <Switch
            color='success'
            checked={data.active}
            onChange={(e) => {
              console.log(' at checked', e.target.checked);
              onActiveChange(data?.id, reminder.id, e.target.checked);
            }}
          />
        </LightTooltip>
      </Box>
    </Box>
  );
};

export default ReminderCard;
